export default __webpack_public_path__ + "static/media/partners-logo-ceragem-w.515a81b5.png";